import React from 'react';
import Box from '@mui/material/Box';
import Rating from '@mui/material/Rating';
import StarIcon from '@mui/icons-material/Star';
import { RatingText } from './Rating.style';
import * as styles from './Rating.style';
export const Review = (rating) => {
    const { sellerReview = 0, sellerRating = 0, iconLeft = true } = rating;
    const rateInteger = sellerRating ? parseInt(sellerRating.replace(/\s+/g, ''), 10) : 0;
    return (React.createElement(Box, { sx: styles.ratingStyle },
        iconLeft && !!sellerReview && (React.createElement(Rating, { sx: styles.starIcon, name: "customized-icons", defaultValue: rateInteger, precision: 0.1, emptyIcon: React.createElement(StarIcon, { sx: styles.emptyStarIcon, fontSize: "inherit" }), readOnly: true })),
        React.createElement(RatingText, { rating: rating }, sellerReview != null ? `${sellerReview} avis` : 'Aucun avis')));
};
